import * as React from 'react';

function HomeIcon() {
    return React.createElement("span", null, "HomeIcon");
}

export { HomeIcon };
//# sourceMappingURL=index.js.map
